import React, { useEffect, useState } from 'react';

import { Fade, IconButton } from '@mui/material';
import { Add } from 'iconsax-react';

import { useTheme } from 'third-party';

type Props = {
  buttonElement: HTMLElement | null;
  onClick: () => void;
};

export const DividerButton: React.FC<Props> = ({ buttonElement, onClick }) => {
  const [visible, setVisible] = useState(false);
  const theme = useTheme();
  useEffect(() => {
    function listener({ clientX, clientY }: MouseEvent) {
      if (!buttonElement) {
        return;
      }
      const rect = buttonElement.getBoundingClientRect();
      const rectY = rect.y;
      const bottomX = rect.x;
      const topX = bottomX + rect.width;

      if (Math.abs(clientY - rectY) < 20) {
        if (bottomX < clientX && clientX < topX) {
          setVisible(true);
          return;
        }
      }
      setVisible(false);
    }
    window.addEventListener('mousemove', listener);
    return () => {
      window.removeEventListener('mousemove', listener);
    };
  }, [buttonElement, setVisible]);

  return (
    <Fade in={visible}>
      <IconButton
        size="small"
        sx={{
          p: 0.12,
          position: 'absolute',
          top: '-12px',
          left: '50%',
          transform: 'translateX(-10px)',
          bgcolor: theme.custom.palette.primary300,
          color: 'primary.contrastText',
          zIndex: 'fab',
          '&:hover, &:active, &:focus': {
            bgcolor: 'brand.blue',
            color: 'primary.contrastText',
          },
        }}
        onClick={ev => {
          ev.stopPropagation();
          onClick();
        }}
      >
        <Add variant="TwoTone" size="20" />
      </IconButton>
    </Fade>
  );
};
